import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canAccessUsersModule } from '../utils/permissions';

/**
 * The audit portal is open to managers and to client users. The server
 * checks that a client was given access to that particular audit.
 */
function PortalRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (canAccessUsersModule(user) || user?.role_name === 'client') {
    return children;
  }

  return <Navigate to="/dashboard" replace />;
}

export default PortalRoute;
